import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import type { Id } from "@/convex/_generated/dataModel";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { PublishAppPage } from "@/components/collection-apps/publish-app-page";

// Publicar una app (o una versión nueva): `?group=` (desde el menú de un
// grupo) o `?listingId=` (editar una app de la empresa).
export const Route = createFileRoute("/_authenticated/settings/_layout/apps/publish")({
  validateSearch: z.object({
    group: z.string().optional(),
    listingId: z.string().optional(),
  }),
  component: PublishAppRoute,
});

function PublishAppRoute() {
  const { group, listingId } = Route.useSearch();
  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["create", "update"] }]}>
      <PublishAppPage key={`${group ?? ""}|${listingId ?? ""}`} group={group} listingId={listingId as Id<"app_listings"> | undefined} />
    </RouteGuardPermissions>
  );
}
